export const FETCH_DIET_CATEGORY = {
  START: 'START_FETCH_DIET_CATEGORY',
  COMPLETE: 'COMPLETE_FETCH_DIET_CATEGORY',
  FAIL: 'FAIL_FETCH_DIET_CATEGORY',
  CLEANUP: 'CLEANUP_FETCH_DIET_CATEGORY',
}

export const UPDATE_DIET_CATEGORY_DETAILS = {
  START: 'START_UPDATE_DIET_CATEGORY_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DIET_CATEGORY_DETAILS',
  FAIL: 'FAIL_UPDATE_DIET_CATEGORY_DETAILS',
}
